"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunk37TESQL4js = require('./chunk-37TESQL4.js');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react = require('react'); var _react2 = _interopRequireDefault(_react);var _jsxruntime = require('react/jsx-runtime');var d=_styled2.default.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${e=>e.theme.measurements.spacing(1)};

  svg {
    color: ${e=>e.theme.palette.PRIMARY};
  }
`,f=_styled2.default.div`
  a {
    font-size: ${e=>e.theme.measurements.spacing(6)};
    line-height: ${e=>e.theme.measurements.spacing(8)};
    font-weight: 600;
    display: block;
    color: ${e=>e.$isCurrentPage?e.theme.palette.SECONDARY:e.theme.palette.PRIMARY};
    text-decoration: none;

    &:hover,
    &:active,
    &:focus {
      text-decoration: ${e=>e.$isCurrentPage?"none":"underline"};
    }
  }
`,h=_styled2.default.call(void 0, _chunk37TESQL4js.b)`
  margin-top: ${e=>e.theme.measurements.spacing(1)};
`,p=_react2.default.forwardRef((e,o)=>{let{fragments:a=[],Link:l="a",className:c,newTab:g=!1}=e;return _jsxruntime.jsx.call(void 0, d,{ref:o,className:`${c||""} aquilla-breadcrumbs breadcrumbs`,children:a.map(({title:t,url:s},m)=>_jsxruntime.jsxs.call(void 0, _react.Fragment,{children:[_jsxruntime.jsx.call(void 0, f,{className:"aquilla-breadcrumbs-fragment breadcrumbs-fragment",$isCurrentPage:m===a.length-1,children:_jsxruntime.jsx.call(void 0, l,{title:t,href:s,as:s,target:g?"_blank":"_self",className:"aquilla-breadcrumbs-link breadcrumbs-link",children:t})}),m!==a.length-1&&_jsxruntime.jsx.call(void 0, h,{className:"aquilla-breadcrumbs-arrow breadcrumbs-arrow",height:16,width:16})]},s||t))})}),P= exports.a =p;exports.a = P;
